import { Payload } from '@smile-next/uikit';
import { NextAccountLoginPageStateProps } from '@/containers/NextAccountLogin/Page/NextAccountLoginPageState';

export class UpdatedNextAccountLoginFormPayload extends Payload {
    type = 'UpdatedNextAccountLoginFormPayload';
    constructor(public readonly updateNextAccountPageStateProps: NextAccountLoginPageStateProps) {
        super();
    }
}
